import React from 'react';
import { CalendarXIcon, BatteryLowIcon, RepeatIcon, AwardIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
const points = [{
  icon: CalendarXIcon,
  label: 'Weekend rubati',
  text: 'Sei stanca di sacrificare i tuoi weekend per scrivere progettazioni e verbali.'
}, {
  icon: BatteryLowIcon,
  label: 'Energia a zero',
  text: 'Arrivi a casa esausta e devi ancora preparare i laboratori per il giorno dopo.'
}, {
  icon: RepeatIcon,
  label: 'Sempre le stesse attività',
  text: 'Senti che proponi sempre le stesse attività e i tuoi alunni si annoiano.'
}, {
  icon: AwardIcon,
  label: 'Vuoi fare la differenza',
  text: 'Vuoi presentare alla Dirigente e ai genitori un programma serio e di prestigio.'
}];
export function ForWhomSection() {
  return <section className="relative w-full bg-bg-dark py-16 sm:py-24 px-4 overflow-hidden" data-id="element-209">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.10) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-210"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(34,224,138,0.06) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-211"></div>

      <div className="relative max-w-5xl mx-auto z-10" data-id="element-212">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-213">
          <span className="inline-flex items-center gap-1.5 text-primary font-bold text-[11px] sm:text-xs uppercase tracking-[0.15em] bg-primary/10 border border-primary/20 px-3 py-1.5 rounded-full mb-4" data-id="element-214">
            <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse-composited" data-id="element-215"></span>
            Ti riconosci?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-[1.1] mb-4" data-id="element-216">
            Questa risorsa è{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-300 via-primary to-orange-500" data-id="element-217">
              per te
            </span>{' '}
            se...
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-218">
            Se ti riconosci in{' '}
            <span className="text-text-main font-bold" data-id="element-219">2 o più</span> di queste
            situazioni, sei nel posto giusto.
          </p>
        </div>

        {/* Points grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-10 sm:mb-12" data-id="element-220">
          {points.map((point, i) => {
          const Icon = point.icon;
          return <div key={i} className="group relative bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-primary/50 hover:bg-bg-alt/80 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(249,115,22,0.15)]" data-id="element-221">
                {/* Icon + label row */}
                <div className="flex items-center gap-3 mb-3" data-id="element-222">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-primary/20 to-orange-500/10 border border-primary/30 flex items-center justify-center flex-shrink-0 group-hover:from-primary/30 group-hover:border-primary/50 transition-colors" data-id="element-223">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" strokeWidth={2} data-id="element-224" />
                  </div>
                  <span className="text-primary font-black text-xs sm:text-sm uppercase tracking-wider" data-id="element-225">
                    {point.label}
                  </span>
                </div>

                {/* Text */}
                <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-226">
                  {point.text}
                </p>

                {/* Subtle check on hover */}
                <div className="absolute top-5 right-5 w-7 h-7 rounded-full bg-cta-green/20 border border-cta-green/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-227">
                  <CheckIcon className="w-4 h-4 text-cta-green" strokeWidth={3} data-id="element-228" />
                </div>
              </div>;
        })}
        </div>

        {/* Bottom confirmation + CTA */}
        <div className="text-center" data-id="element-229">
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-5 bg-cta-green/10 border border-cta-green/30 rounded-2xl px-6 py-5 sm:py-4" data-id="element-230">
            <div className="flex items-center gap-2.5" data-id="element-231">
              <div className="w-7 h-7 rounded-full bg-cta-green/20 border border-cta-green/40 flex items-center justify-center flex-shrink-0" data-id="element-232">
                <CheckIcon className="w-4 h-4 text-cta-green" strokeWidth={3} data-id="element-233" />
              </div>
              <p className="text-text-main text-sm sm:text-base font-bold" data-id="element-234">
                Allora <span className="text-cta-green" data-id="element-235">Arte Pronta</span> è
                stato creato per te.
              </p>
            </div>
            <a href="#pricing" className="group inline-flex items-center gap-1.5 text-cta-green hover:text-cta-green-hover font-bold text-sm sm:text-base transition-colors whitespace-nowrap" data-id="element-236">
              Scopri l'offerta
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={3} data-id="element-237" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}